
import _propertyOf from "lodash/propertyOf"

const ObjectFinder = {
  findObjectByPath(path: string, scope_object = null) {
    // If any falsy thing passed in, replace with `window`
    const cur_scope = scope_object || window

    // We should strip "window." since we cannot find `window` in `window`
    path.replace(/^window\./, "")
    .replace(/\[(\w+)]/g, ".$1")// convert indexes to properties
    .replace(/^\./, "") // strip a leading dot

    const ar = path.split(".")

    return ar.reduce((scope, key) => _propertyOf(scope)(key), cur_scope)
  },
}

export default ObjectFinder
